import { deleteApi, getApi, postApi, putApi } from "./general.service";

export const getUsers = async (data) => {
  const page = (data?.skip ?? 0) + 1;
  const users = getApi(
    `/admin/user?take=${data?.take || 20}&page=${page}${
      data?.search ? `&search=${encodeURIComponent(data.search)}` : ""
    }${data?.orderBy ? `&orderBy=${data.orderBy}` : ""}${
      data?.order ? `&order=${data.order}` : ""
    }${data?.level ? `&level=${encodeURIComponent(data.level)}` : ""}${
      data?.role ? `&role=${encodeURIComponent(data.role)}` : ""
    }${data?.nextPageHash ? `&nextPageHash=${data.nextPageHash}` : ""}`,
    data
  );
  return users;
};

export const getUser = async (data) => {
  const users = getApi(`/admin/user/${data._id}`, data);
  return users;
};

export const createUser = async (data) => {
    const users = postApi("/admin/user", data);
    return users;
};

export const updateUser = async (data) => {
    const users = putApi("/admin/user", data);
    return users;
};

export const deleteUser = async (data) => {
    const users = deleteApi(`/admin/user?_id=${data._id}`, data);
    return users;
};